const getPlural = (text, numberOfItems) => `${text}${numberOfItems === 1 ? '' : 's'}`;

// eslint-disable-next-line import/prefer-default-export
export { getPlural };
